import { Link, useLocation } from "react-router-dom";
import Seo from "@/components/site/Seo";
import PageHero from "@/components/site/PageHero";
import { site } from "@/data/content";

const docs = {
  privacy: {
    title: "Privacy Policy",
    sections: [
      ["Who we are", `${site.legalName} ("Immistop", "we") is an immigration advisory firm based in Ahmedabad, India. This policy explains how we collect, use and protect your personal information.`],
      ["Information we collect", "We collect information you provide through our enquiry, eligibility and consultation forms, such as your name, contact details, destination and service interests, and any details you choose to share about your education, experience or financial capacity."],
      ["How we use it", "We use your information solely to respond to your enquiry, assess your requirements, provide our services and meet our legal obligations. We do not sell your personal information."],
      ["Sharing", "We share information only with your consent and only where necessary to progress your matter — for example, with authorised legal partners or the relevant government authorities as part of an application."],
      ["Cookies", "We use essential cookies to operate this website and, with your consent, analytics cookies to understand how it is used. You can change your preference at any time by clearing your browser's site data."],
      ["Retention & security", "We retain information only as long as needed for the purposes described or as required by law, and we apply appropriate technical and organisational safeguards."],
      ["Your rights", `You may request access to, correction of or deletion of your personal information by writing to ${site.email}.`],
    ],
  },
  terms: {
    title: "Terms of Use",
    sections: [
      ["Acceptance", "By using this website you agree to these terms. If you do not agree, please do not use the website."],
      ["Information only", "Content on this website is general information and does not constitute legal or immigration advice. Advice is provided only under a written engagement."],
      ["Engagements", "Our services, scope and fees are confirmed in a written engagement letter before any work begins. No fees are stated on this website."],
      ["Accuracy", "Immigration rules change frequently. While we strive to keep content current, we make no warranty that it is complete or up to date at any time."],
      ["Intellectual property", "All content, design and branding on this website belong to Immistop and may not be reproduced without permission."],
      ["Governing law", "These terms are governed by the laws of India, and the courts of Ahmedabad, Gujarat shall have jurisdiction."],
    ],
  },
  disclaimer: {
    title: "Disclaimer",
    sections: [
      ["No guarantee of outcome", "Immistop provides advisory, documentation and support services. We do not and cannot guarantee the grant of any visa, permit, residence, citizenship or other immigration outcome."],
      ["Government discretion", "All immigration decisions rest solely with the relevant government authorities, embassies, consulates and designated bodies, which act independently of Immistop."],
      ["Indicative timelines", "Any timelines referred to are indicative only. Processing times are determined by the relevant authority and may change without notice."],
      ["Subject to eligibility", "All services and pathways described on this website are subject to eligibility under the rules in force at the time of application."],
      ["Third parties", "Where we coordinate with licensed lawyers, investment agents or other professionals, those parties are responsible for their own advice and services."],
    ],
  },
};

export default function Legal() {
  const key = useLocation().pathname.slice(1);
  const d = docs[key] || docs.privacy;
  return (
    <>
      <Seo title={d.title} description={`${d.title} for ${site.legalName}.`} />
      <PageHero compact eyebrow="Legal" lines={[d.title]} image="/img/london-city.jpg" testid={`legal-hero-${key}`} />
      <section className="section-lux bg-ivory" data-testid={`legal-${key}`}>
        <div className="container-lux max-w-3xl">
          {d.sections.map(([h, p], i) => (
            <div key={h} className="border-b border-navy/15 py-8">
              <h2 className="font-serif text-3xl text-navy"><span className="mr-4 font-sans text-[12px] tracking-[0.25em] text-gold-deep">0{i + 1}</span>{h}</h2>
              <p className="mt-4 text-[16px] leading-relaxed text-charcoal">{p}</p>
            </div>
          ))}
          <p className="mt-10 text-[13px] text-charcoal-soft">Questions? Contact us at <a className="link-lux text-navy" href={`mailto:${site.email}`}>{site.email}</a> or <Link to="/contact" className="link-lux text-navy">book a consultation</Link>.</p>
        </div>
      </section>
    </>
  );
}
